import produce from 'immer';

import {
  COURSE_SELECT,
  COURSE_NEXT_LESSON,
  COURSE_PREV_LESSON,
  COURSE_SELECT_LESSON,
  COURSE_COMPLETE_LESSON,
  FETCH_COURSES_INIT,
  FETCH_COURSES_SUCCESS,
  FETCH_COURSES_FAILED,
  ADD_POST_INIT,
  ADD_POST_SUCCESS,
  ADD_POST_FAILED,
  FETCH_FORUM_INIT,
  FETCH_FORUM_SUCCESS,
  FETCH_FORUM_FAILED,
  FETCH_TERMS_SUCCESS,
  SET_COURSE_ERROR,
} from '../actionTypes';

const defaultState = {
  courses: [],
  currentCourse: 0,
  currentLesson: 0,
  completedLessons: [],
  posts: [],
  loading: false,
  progressChanged: false,
  terms: [],
  error: null,
};

const courseReducer = (state = defaultState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_COURSE_ERROR:
        draft.error = action.payload;
        break;
      case FETCH_TERMS_SUCCESS:
        draft.terms = action.terms;
        break;
      case FETCH_COURSES_INIT:
        const { curriculumId } = action.payload;

        const prevCurriculumId = localStorage.getItem('curriculum_id');
        if (prevCurriculumId && prevCurriculumId === curriculumId) {
          draft.currentCourse = Number(localStorage.getItem('course_id')) || 0;
          draft.currentLesson = Number(localStorage.getItem('lesson_id')) || 0;
        } else {
          localStorage.setItem('curriculum_id', curriculumId);
          draft.currentCourse = 0;
          draft.currentLesson = 0;
        }
        draft.loading = true;
        break;
      case FETCH_COURSES_SUCCESS:
        let courses = [...action.payload.courses];
        courses.sort((a, b) => a.no - b.no);
        courses = [
          ...courses.filter(({ no }) => !!no),
          ...courses.filter(({ no }) => !no),
        ];
        draft.courses = courses.map((course, index) => {
          let content = [...course.lessons, ...course.quizzes];
          content.sort((a, b) => a.no - b.no);
          content = [
            ...content.filter(({ no }) => !!no),
            ...content.filter(({ no }) => !no),
          ];
          delete course.lessons;

          return {
            ...course,
            title: `COURSE ${index + 1}: ${course.title.toUpperCase()}`,
            lessonAndQuizzes: content,
          };
        });
        draft.completedLessons = action.payload.completedLessons;

        draft.loading = false;
        break;
      case FETCH_COURSES_FAILED:
        console.log('[action.payload],', action.payload, action.error);
        draft.loading = false;
        break;
      case COURSE_SELECT:
        const { id } = action;

        if (draft.currentCourse !== id) {
          draft.currentLesson = 0;
        }
        draft.currentCourse = id;

        localStorage.setItem('course_id', draft.currentCourse);
        localStorage.setItem('lesson_id', draft.currentLesson);
        break;
      case COURSE_NEXT_LESSON: {
        const { currentLesson, currentCourse, courses } = draft;
        if (
          courses[currentCourse] &&
          currentLesson === courses[currentCourse].lessonAndQuizzes.length - 1
        ) {
          if (currentCourse === courses.length - 1) {
            break;
          }

          draft.currentCourse += 1;
          draft.currentLesson = 0;
        } else {
          draft.currentLesson += 1;
        }
        localStorage.setItem('course_id', draft.currentCourse);
        localStorage.setItem('lesson_id', draft.currentLesson);
        break;
      }
      case COURSE_PREV_LESSON: {
        const { currentLesson, currentCourse } = draft;
        if (currentLesson === 0) {
          if (currentCourse === 0) {
            break;
          }

          draft.currentCourse -= 1;
          draft.currentLesson = 0;
        } else {
          draft.currentLesson -= 1;
        }
        localStorage.setItem('course_id', draft.currentCourse);
        localStorage.setItem('lesson_id', draft.currentLesson);
        break;
      }
      case COURSE_SELECT_LESSON:
        draft.currentLesson = action.id;
        localStorage.setItem('lesson_id', draft.currentLesson);
        break;
      case COURSE_COMPLETE_LESSON: {
        const {
          courses,
          completedLessons,
          currentCourse,
          currentLesson,
        } = draft;

        const currentLessonId =
          courses[currentCourse].lessonAndQuizzes[currentLesson]._id;
        if (completedLessons.includes(currentLessonId) && !action.isComplete) {
          draft.completedLessons = completedLessons.filter(
            (id) => id !== currentLessonId
          );
        } else if (action.isComplete) {
          draft.completedLessons = [...completedLessons, currentLessonId];
        }

        draft.progressChanged = !draft.progressChanged;
        break;
      }
      case ADD_POST_SUCCESS:
        const cPosts = draft.posts.slice();
        const { isComment } = action.payload;
        if (isComment) {
          for (let i = 0; i < cPosts.length; i += 1) {
            if (cPosts[i].id === action.payload.parentId) {
              cPosts[i].comments.push(action.payload);
            }
          }
        } else {
          cPosts.push(action.payload);
        }

        draft.posts = cPosts;
        break;
      case ADD_POST_FAILED:
        break;
      case FETCH_FORUM_INIT:
        break;
      case FETCH_FORUM_SUCCESS:
        draft.posts = action.payload;
        break;
      case FETCH_FORUM_FAILED:
        break;
      default:
        break;
    }
  });

export default courseReducer;
